import React from 'react'
// import PropTypes from 'prop-types'

const CustomSymbol = ({ color='#7C3F88', margin, symbol='>' }) => {
  return (
    <div style={{color, margin}} className='custom_greaterThan'>{symbol}</div>
  )
}

const RowLocation = ({ division, department, line, brand, locationName, onClickEdit, onClickDelete }) => {
  return (
    <div className='location-item'>
      <div className='location-info'>
        <h2>{division}</h2>
        <CustomSymbol color='#999999' margin='0 .6em'/>
        <h2>{department}</h2>
        { line &&
          <>
            <CustomSymbol color='#999999' margin='0 .6em'/>
            <h2>{line}</h2>
          </>
        }
        { brand &&
          <>
            <CustomSymbol color='#999999' margin='0 .6em' symbol='-'/>
            <h2>{brand}</h2>
          </>
        }
      </div>
      <div className='location-floor'>
        <img src={require('../../../assets/icons/mdi_map-marker.svg')} alt='map-marker' />
        <h2>{locationName}</h2>
      </div>
      <div className='location-buttons'>
        <div onClick={onClickEdit}>
          <img src={require('../../../assets/icons/edit.svg')} alt='editar' />
        </div>
        <div onClick={onClickDelete}>
          <img src={require('../../../assets/icons/delete.svg')} alt='borrar' />
        </div>
      </div>
    </div>
  )
}

RowLocation.propTypes = {

}

export default RowLocation

